import { useEffect, useState } from "react";
import BonusGrid from "../components/BonusGrid";
import Header from "../components/Header";
import Navigation from "../components/Navigation";
import LanguageSelector from "../components/LanguageSelector";
import MaintenanceMode from "../components/MaintenanceMode";
import { useStatic } from "../context/StaticContext";
import { useBonus } from "../context/BonusContext";
import { useAdmin } from "../context/AdminContextNew";
import AdminLoginModal from "../components/AdminLoginModal";
import CssEditButton from "../components/CssEditButton";
import CssPanelNew from "../components/CssPanelNew";
import { CircularProgress } from "@mui/material";
import logo from "../assets/logo.png";
import HistoryPopup from "../components/HistoryPopup";

const HomePage = () => {
  const { updateMode, isLanguage } = useStatic();
  const { fetchBonusForUser, fetchGamesForUser, userName, loading, error, userId } = useBonus();
  const {
    showLoginModal,
    setShowLoginModal,
    handleLogin,
    showCssEditButton,
    handleEditCss,
    showCssPanel,
    handleCloseCssPanel,
  } = useAdmin();

  const [activeBackground, setActiveBackground] = useState(null);
  const [historyPopupOpen, setHistoryPopupOpen] = useState(false);

  // Bonus başarıyla talep edildiğinde çağrılacak callback
  const handleBonusSuccess = () => {
    // Alert kapandıktan sonra history popup'ı aç
    setTimeout(() => {
      setHistoryPopupOpen(true);
    }, 1200); // Alert'in kapanması için biraz bekleme süresi
  };

  // History popup kapatma fonksiyonu
  const handleCloseHistoryPopup = () => {
    setHistoryPopupOpen(false);
  };

  useEffect(() => {
    const setBackgroundStyle = () => {
      const isMobile = window.innerWidth <= 768;

      setActiveBackground(
        isMobile ? "images/bg-image-mobile.webp" : "images/bg-image.webp"
      );
    };

    setBackgroundStyle();
    window.addEventListener("resize", setBackgroundStyle);

    return () => window.removeEventListener("resize", setBackgroundStyle);
  }, []);

  useEffect(() => {
    fetchBonusForUser();
    fetchGamesForUser();
  }, [fetchBonusForUser, fetchGamesForUser]);

  // Dil değiştiğinde bonusları ve oyunları yeniden yükle
  useEffect(() => {
    if (isLanguage) {
      fetchBonusForUser();
      fetchGamesForUser();
    }
  }, [isLanguage, fetchBonusForUser, fetchGamesForUser]);

  if (updateMode) {
    return <MaintenanceMode />;
  }

  // Hata durumlarını kontrol et
  if (error) {
    const getErrorMessage = (errorType) => {
      switch (errorType) {
        case "invalid_access":
          return "Geçersiz erişim";
        case "user_blocked":
          return "Kullanıcı engellenmiştir";
        case "user_not_found":
          return "Kullanıcı bulunamadı";
        case "api_error":
          return "API hatası oluştu";
        case "connection_error":
          return "Bağlantı hatası";
        default:
          return "Bilinmeyen hata";
      }
    };

    const getErrorDescription = (errorType) => {
      switch (errorType) {
        case "invalid_access":
          return "URL'yi kontrol edin veya daha sonra tekrar deneyin.";
        case "user_blocked":
          return "Bu içeriğe erişim izniniz bulunmamaktadır. CORS politikası veya sunucu tarafından engellenmiş olabilirsiniz.";
        case "user_not_found":
          return "Kullanıcı bilgileri bulunamadı. URL'yi kontrol edin.";
        case "api_error":
          return "Sunucu hatası oluştu. Lütfen daha sonra tekrar deneyin.";
        case "connection_error":
          return "İnternet bağlantınızı kontrol edin ve tekrar deneyin.";
        default:
          return "Bir hata oluştu. Lütfen daha sonra tekrar deneyin.";
      }
    };

    return (
      <div className="loading-container">
        <div className="error-message">
          <h2 style={{ color: "#ff4757", marginBottom: "10px" }}>
            {getErrorMessage(error)}
          </h2>
          <p style={{ color: "#666", fontSize: "14px", lineHeight: "1.4" }}>
            {getErrorDescription(error)}
          </p>
          {error === "user_blocked" && (
            <div style={{ 
              marginTop: "15px", 
              padding: "10px", 
              backgroundColor: "rgba(255, 71, 87, 0.1)", 
              borderRadius: "8px",
              border: "1px solid rgba(255, 71, 87, 0.2)"
            }}>
              <p style={{ color: "#ff4757", fontSize: "12px", margin: 0 }}>
                🚫 Bu genellikle CORS politikası veya 403 sunucu engellemesi nedeniyle oluşur.
              </p>
            </div>
          )}
        </div>
      </div>
    );
  }

  if (loading) {
    return (
      <div className="loading-container">
        <CircularProgress
          size={60}
          thickness={4}
          sx={{
            color: "#1475E1",
            "& .MuiCircularProgress-circle": {
              strokeLinecap: "round",
            },
          }}
        />
        {!userId && (
          <p style={{ marginTop: "20px", color: "#666" }}>
            Geçersiz erişim
          </p>
        )}
      </div>
    );
  }
  return (
    <div
      className="app-container"
      style={{
        backgroundImage: `url('/${activeBackground}')`,
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundRepeat: "no-repeat",
      }}
    >
      {/* Admin Login Modal */}
      <AdminLoginModal
        open={showLoginModal}
        onClose={() => setShowLoginModal(false)}
      />

      {/* CSS Edit Button */}
      {showCssEditButton && <CssEditButton onClick={handleEditCss} />}

      {/* CSS Panel */}
      <CssPanelNew open={showCssPanel} onClose={handleCloseCssPanel} />

              {/* Language Selector - sağ üst köşede sabit */}
        {isLanguage && <LanguageSelector />}

        {/* Ana İçerik */}
        <div className="content-container">
        {/* Header */}
        <Header username={userName} />
        {/* Navigation */}
        <Navigation />

        {/* Otobonüs Bonus Kartları */}
        <BonusGrid onBonusSuccess={handleBonusSuccess} />

        {/* Sağ Alt Köşe Logo
         <div className="corner-logo" onClick={() => window.open('https://hookdijital.com/', '_blank')}>
          <img src={logo} alt="Logo" />
        </div>

        */}
       
      </div>

      {/* History Popup - Header'daki ile ayrı olarak global seviyede */}
      <HistoryPopup isOpen={historyPopupOpen} onClose={handleCloseHistoryPopup} />
    </div>
  );
};

export default HomePage;
